import React, { ComponentType } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../data-layer/authentication/service';
import { isAdmin, isDeclinedAdmin, isSuperAdmin, isSupport } from '../utils/accessService';
import { withInvariant } from '../utils/withInvariant';
import { useCurrentUser } from './users/useCurrentUser';

export function withBusinessAuthProtection<TProps extends {}>(
    BaseComponent: ComponentType<TProps>,
): ComponentType<TProps> {
    return withInvariant(
        (props: TProps) => {
            const currentUser = useCurrentUser();

            if (!isAuthenticated()) {
                return (
                    <Navigate
                        to={`${process.env.REACT_APP_PASSPORT_URL}/auth?retpath=${window.location.href}`}
                    />
                );
            }

            if (!currentUser) {
                return null;
            }

            if (
                currentUser &&
                !isAdmin(currentUser.role) &&
                !isSuperAdmin(currentUser.role) &&
                !isSupport(currentUser.role) &&
                !isDeclinedAdmin()
            ) {
                return <Navigate to="/" />;
            }

            // @ts-ignore
            return <BaseComponent {...props} />;
        },
        () => null,
    );
}
